import request from '@/utils/request'
export function fetchList(params) {
  return request({
    url:'/manuscript/list',
    method:'get',
    params:params
  })
}
export function createManuscript(data) {
  return request({
    url:'/manuscript/create',
    method:'post',
    data:data
  })
}
export function updateVerifyStatus(params) {
  return request({
    url:'/manuscript/update/verifyStatus',
    method:'post',
    params:params
  })
}
export function deleteManuscripts(params) {
  return request({
    url:'/manuscript/delete/batch',
    method:'post',
    params:params
  })
}
export function deleteManuscript(id) {
  return request({
    url:'/manuscript/delete/'+id,
    method:'get',
  })
}

export function getManuscript(id) {
  return request({
    url:'/manuscript/'+id,
    method:'get',
  })
}

export function updateManuscript(id,data) {
  return request({
    url:'/manuscript/update/'+id,
    method:'post',
    data:data
  })
}




// WEBPACK FOOTER //
// ./src/api/manuscript.js